import {useEffect, useRef, useState} from 'react';
import api from '../api';

export default function useBillingOrganizationRefresh(org, dispatch) {
    const currentOrg = useRef(org);
    currentOrg.current = org;
    const [refreshFailed, setRefreshFailed] = useState(false);

    useEffect(() => {
        if (!org?.id) return;
        let request = 0;
        let active = true;
        const refresh = () => {
            const previousOrg = currentOrg.current;
            const token = ++request;
            api.get(`/api/organizations/${org.id}`).then(({data}) => {
                if (!active || token !== request || data.id !== org.id) return;
                dispatch({type: 'billing_org_refreshed', org: data, previousOrg});
                setRefreshFailed(false);
            }).catch(() => {
                if (active && token === request) setRefreshFailed(true);
            });
        };
        refresh();
        window.addEventListener('focus', refresh);
        return () => {
            active = false;
            window.removeEventListener('focus', refresh);
        };
    }, [org?.id, dispatch]);

    return refreshFailed;
}
